export default __webpack_public_path__ + "static/media/loader.c8e85810.gif";